import * as React from 'react';

import './style.scss';

interface ITabsProps {
  children: any;
  activeTab?: number;
  onTabChange?: (index: number) => void;
}

interface ITabsState {
  activeTab: number;
}

export default class Tabs extends React.Component<ITabsProps, ITabsState> {
  constructor(props: ITabsProps) {
    super(props);

    this.state = {
      activeTab: props.activeTab ?? 0,
    };
  }

  componentDidUpdate(prevProps: Readonly<ITabsProps>) {
    const { activeTab } = this.props;

    if (activeTab && activeTab !== prevProps.activeTab) {
      this.setState({
        activeTab,
      });
    }
  }

  onTabClick = (
    e: React.MouseEvent<HTMLElement>,
    index: number,
    onClickProp: (e: React.SyntheticEvent<HTMLElement>) => void
  ) => {
    const { onTabChange } = this.props;

    this.setState(
      {
        activeTab: index,
      },
      () => {
        if (onTabChange) {
          onTabChange(index);
        }
        onClickProp(e);
      }
    );
  };

  isTab = (element) => element.type && element.type.name === 'Tab';

  isTabName = (element) => element.type && element.type.name === 'TabName';

  isTabContent = (element) => element.type && element.type.name === 'TabContent';

  renderTabs = () => {
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];

    const tabs = children.reduce((namesAndContent, child, index) => {
      const tabProps = child?.props;
      const tabChildren = tabProps && tabProps.children;

      if (tabChildren) {
        /**
         * A hacky fix which considers
         * first element as tabName, and
         * second element as tabContent.
         * Needs a re-visit in future.
         */
        const tabName = tabChildren[0];
        const tabContent = tabChildren[1];

        if (tabName) {
          namesAndContent.push({
            tabName,
            tabContent,
            tabProps,
          });
        }
      }

      return namesAndContent;
    }, []); // tslint:disable-line

    const tabsNames = tabs.map((namesAndContent, index) => {
      const onTabClickProp = namesAndContent.tabProps.onClick ? namesAndContent.tabProps.onClick : () => null;

      return React.cloneElement(namesAndContent.tabName, {
        onClick: (e) => this.onTabClick(e, index, onTabClickProp),
        isActive: this.state.activeTab === index,
        key: index,
      });
    });
    const tabContents = tabs.map((namesAndContent, index) =>
      React.cloneElement(namesAndContent.tabContent, {
        isActive: this.state.activeTab === index,
        key: index,
      })
    );

    return (
      <div className="tabs">
        <div className="tabs__names">{tabsNames}</div>
        <div className="tabs__contents">{tabContents}</div>
      </div>
    );
  };

  render() {
    return this.renderTabs();
  }
}
